import React, { useContext, useEffect, useRef, useState } from 'react'
import { useMediaQuery } from '@mui/material'
import { Dialog } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {
  CAMCMethodButtonContainer,
  CAMCMethodButtonImage,
  CAMCGeneralButton,
  CAMCParent,
  CAMCSeparator,
  CAMCGeneralInput,
  CAMCHeading,
  CAMCMaxWithRelativeContainer,
  CAMCGeneralInputLabel,
  CAMCErrorText,
  CAMCPhoneInput,
  CAMCCaptcha,
  CAMCResendOtpContainer,
} from './ClubbedAuthStyles'
import OtpInput from '../OtpInput'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import {
  handleAppleLogin,
  handleFacebookLogin,
  handleGoogleLogin,
} from 'src/consumer/services/loginLogoutHandlers'
import { toast } from 'react-toastify'
import SmsIcon from '@mui/icons-material/Sms'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { DisplayFlex } from '../../ConsumerProfilePage/ProfileLeftPannelStyle'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import ErrorIcon from '@mui/icons-material/Error'
import { prepareDataForRegistration, prepareDataForUpdate } from '../../Form/helpers/dataHelpers'
import { postData, getData } from 'src/consumer/services/profileService'
import { Spinner } from 'react-bootstrap'
import { SignIn } from 'src/services/APIs/Login/Login'
import { validateEmail } from 'src/consumer/helpers/utilFunctions'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { parsePhoneNumber } from 'libphonenumber-js'
import { RecaptchaVerifier, signInWithPhoneNumber, getAuth, onAuthStateChanged, initializeRecaptchaConfig } from 'firebase/auth'
import { getFirebaseAuth, default as app } from 'src/firebase'
import {
  verifyLogin,
  sendEmailLoginOtp,
  sendWhatsAppOtp,
  verifyEmailLoginOtp,
  verifyWhatsAppOtp,
} from 'src/consumer/services'
import { isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'
import { RectangleRadioButton } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'
import { INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE } from './utils'
import { isValidEmail } from 'src/clinic/views/onboardng/clinicBrand/components/utils'
import { useNavigate } from 'react-router'
import { setAccessTokenExpiry } from 'src/consumer/services/localstorageServices'

// Single switch for social login provider visibility in the modal. Backend
// policy flags (unSecureSetupData.loginPolicy.login.*) are unchanged — this
// only hides the buttons client-side. Flip a flag here to bring a provider
// back without touching any other code.
const CLUBBED_AUTH_SOCIAL_PROVIDERS = {
  google: true,
  facebook: false,
  apple: false,
}

//////////////////////////////////////////////// helper components

export function ClubbedAuthModal({
  loginVariant = false,
  noCloseButton,
  onClose,
  nameFieldHeading,
  loginFieldHeading,
  preferredLoginInputType,
  preferredLoginInputValue,
  beforeReloadFunction,
  redirectToURI,
  initialOnboardingDetails,
  ...rest
}) {
  return (
    <Dialog
      {...rest}
      PaperProps={{
        sx: {
          padding: { xs: '28px 20px 24px', sm: '36px 32px 28px' },
          margin: { xs: '10px', sm: '24px' },
          maxWidth: { xs: 'calc(100% - 20px)', sm: '480px' },
          width: { xs: 'calc(100% - 20px)', sm: '480px' },
          borderRadius: '20px',
          overflow: 'auto',
          maxHeight: { xs: 'calc(100vh - 20px)', sm: '92vh' },
          boxShadow: '0 24px 60px rgba(15, 23, 42, 0.18)',
          // Centre the single-column form inside the Paper so there is no
          // asymmetric gutter on desktop.
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        },
      }}
      sx={{
        '& .MuiDialog-container': {
          overflow: 'auto',
        },
        '& .MuiDialog-paper': {
          overflow: 'auto',
        }
      }}
    >
      {!noCloseButton && (
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '36px',
            height: '36px',
            borderRadius: '10px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 0,
            background: '#f1f5f9',
            color: '#475569',
            cursor: 'pointer',
            transition: 'background-color 0.15s ease, color 0.15s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#e2e8f0'
            e.currentTarget.style.color = '#0f172a'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#f1f5f9'
            e.currentTarget.style.color = '#475569'
          }}
        >
          <CloseIcon sx={{ fontSize: '20px' }} />
        </button>
      )}
      <ClubbedAuthMainComponent
        theme="light"
        doBasicOnboardingInside={true}
        loginVariant={loginVariant}
        nameFieldHeading={nameFieldHeading}
        loginFieldHeading={loginFieldHeading}
        preferredLoginInputType={preferredLoginInputType}
        preferredLoginInputValue={preferredLoginInputValue}
        beforeReloadFunction={beforeReloadFunction}
        redirectToURI={redirectToURI}
        initialOnboardingDetails={initialOnboardingDetails}
      />
    </Dialog>
  )
}

export const CAMCSocialLoginComponent = ({ type, clickFunction, isActive = false }) => {
  let image
  let text
  switch (type) {
    case 'email':
      image = 'email-logo.svg'
      text = 'Email & password'
      break
    case 'mobile':
      text = 'Mobile number'
      break
    case 'google':
      image = 'google-colored.png'
      text = 'Continue with Google'
      break
    case 'facebook':
      image = 'facebook-colored.png'
      text = 'Continue with Facebook'
      break
    case 'apple':
      image = 'apple-colored.png'
      text = 'Continue with Apple'
      break
    default:
      break
  }
  return (
    <CAMCMethodButtonContainer
      onClick={clickFunction}
      style={{
        backgroundColor: isActive ? '#f5f3ff' : '#ffffff',
        borderColor: isActive ? '#7c3aed' : '#e2e8f0',
      }}
    >
      {image && <CAMCMethodButtonImage src={image} alt={text} onError={(e) => { e.target.style.display = 'none' }} />}
      {text}
    </CAMCMethodButtonContainer>
  )
}

/////////////////////////////////////////// helper functions

/**
 * Validates redirect URL to prevent infinite loops and security issues
 */
const isValidRedirectURI = (uri) => {
  if (!uri || typeof uri !== 'string') {
    return false
  }
  
  try {
    // Decode the URI first to check the actual path
    const decodedUri = decodeURIComponent(uri)
    
    // Prevent redirect to login pages (infinite loop protection)
    const loginPaths = [
      '/login',
      '/workplace/login',
      '/support-home/login',
      '/clinic-home/login',
      '/mentor-home/login',
      '/aumhum-for-clinics',
    ]
    
    const isLoginPage = loginPaths.some(path => decodedUri.startsWith(path))
    if (isLoginPage) {
      return false
    }
    
    // Ensure URL is relative (same origin) - prevent open redirects
    if (decodedUri.startsWith('http://') || decodedUri.startsWith('https://') || decodedUri.startsWith('//')) {
      return false
    }
    
    // Ensure URL starts with / (relative path)
    if (!decodedUri.startsWith('/')) {
      return false
    }
    
    return true
  } catch (error) {
    // If decoding fails, it's not a valid redirect URI
    return false
  }
}

const handleAfterLoginCAMC = async (
  response,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
  beforeReloadFunction,
  redirectToURI,
) => {
  if (response.status === 200) {
    localStorage.setItem('token', response.data.accessToken)
    setAccessTokenExpiry({ accessTokenExpiry: response.data.accessTokenExpiry })
    localStorage.setItem('authorities', JSON.stringify(response.data.authorities))
    
    // Validate redirect URI before using it
    const safeRedirectURI = redirectToURI && isValidRedirectURI(redirectToURI) 
      ? redirectToURI 
      : null
    
    if (doBasicOnboardingInside) {
      // Fetch full user profile to check basic onboarding status
      // WhatsApp login response only contains token/authorities, not full profile
      try {
        const profileResponse = await getData('/api/secure/user/profile')
        if (profileResponse?.status === 200) {
          const profileData = profileResponse.data
          setProfileDataForBasicOnboarding(profileData)
          
          if (isBasicOnboardingDone(profileData)) {
            beforeReloadFunction && beforeReloadFunction()
            if (safeRedirectURI) {
              window.location.href = decodeURIComponent(safeRedirectURI)
            } else {
              window.location.reload()
            }
          } else {
            setBasicOnboardingFlowVisible(true)
          }
        } else {
          // If profile fetch fails, proceed with reload (profile will be fetched on next page)
          beforeReloadFunction && beforeReloadFunction()
          if (safeRedirectURI) {
            window.location.href = decodeURIComponent(safeRedirectURI)
          } else {
            window.location.reload()
          }
        }
      } catch (error) {
        // If profile fetch fails, proceed with reload (profile will be fetched on next page)
        console.error('Error fetching user profile:', error)
        beforeReloadFunction && beforeReloadFunction()
        if (safeRedirectURI) {
          window.location.href = decodeURIComponent(safeRedirectURI)
        } else {
          window.location.reload()
        }
      }
    } else {
      // If not doing basic onboarding inside, use response data if available, otherwise fetch profile
      if (response?.data?.name || response?.data?.dob) {
        // Response has profile data (e.g., from Firebase login)
        setProfileDataForBasicOnboarding(response?.data)
      } else {
        // Response only has token/authorities (e.g., from WhatsApp login)
        // Profile will be fetched on next page load
        setProfileDataForBasicOnboarding(response?.data)
      }
      
      beforeReloadFunction && beforeReloadFunction()
      if (safeRedirectURI) {
        window.location.href = decodeURIComponent(safeRedirectURI)
      } else {
        window.location.reload()
      }
    }
  } else {
    if (setErrorText) {
      setErrorText(response?.response?.data?.message || 'Error Logging In')
    } else {
      toast.error(response?.response?.data?.message || 'Error Logging In')
    }
  }
}

// Helper function to parse Firebase error messages
const parseFirebaseError = (error) => {
  if (error?.code) {
    switch (error.code) {
      case 'auth/invalid-app-credential':
        return 'Authentication error. Please refresh the page and try again.'
      case 'auth/too-many-requests':
        return 'Too many attempts. Please try again later or use WhatsApp login.'
      case 'auth/invalid-phone-number':
        return 'Invalid phone number. Please check and try again.'
      case 'auth/quota-exceeded':
        return 'SMS quota exceeded. Please try again later or use WhatsApp login.'
      case 'auth/captcha-check-failed':
        return 'reCAPTCHA verification failed. Please try again.'
      default:
        if (error.message?.includes('TOO_MANY_ATTEMPTS')) {
          return 'Too many attempts. Please try again later or use WhatsApp login.'
        }
        return error.message || 'Error sending OTP'
    }
  }
  return 'Error sending OTP'
}

// Store global verifier reference to clean up properly
let globalRecaptchaVerifier = null

const sendOtp = async (
  number,
  setShowOtpInput,
  setErrorText,
  setMobileNumberInputDisabled,
  setConfirmationResultMobileLogin,
  setOtpMethod,
) => {
  const auth = getFirebaseAuth()

  // Clean up any existing reCAPTCHA verifier
  if (globalRecaptchaVerifier) {
    try {
      globalRecaptchaVerifier.clear()
    } catch (e) {
      // Ignore cleanup errors
    }
    globalRecaptchaVerifier = null
  }
  
  // Clear the container
  const container = document.getElementById('recaptcha-container')
  if (container) {
    container.innerHTML = ''
  }
  
  // Firebase v11+ requires initializing reCAPTCHA config before phone auth
  try {
    await initializeRecaptchaConfig(auth)
  } catch (configError) {
    // Config initialization can fail but phone auth may still work
  }

  let CaptchaVerifier
  try {
    // Use invisible reCAPTCHA - Firebase will auto-render when needed
    CaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
      'size': 'invisible'
    })
    globalRecaptchaVerifier = CaptchaVerifier
  } catch (verifierError) {
    console.error('RecaptchaVerifier creation failed:', verifierError)
    setErrorText('Failed to initialize reCAPTCHA')
    return
  }
  
  return signInWithPhoneNumber(auth, number, CaptchaVerifier)
    .then((confirmationResult) => {
      setShowOtpInput(true)
      setMobileNumberInputDisabled(false)
      setConfirmationResultMobileLogin(confirmationResult)
      if (setOtpMethod) setOtpMethod('sms')
      return confirmationResult
    })
    .catch((error) => {
      console.error('Error sending OTP:', error)
      setErrorText(parseFirebaseError(error))
    })
}

const resendOtp = async (
  number,
  setShowOtpInput,
  setErrorText,
  setMobileNumberInputDisabled,
  setConfirmationResultMobileLogin,
  resetSecondsTimeout,
  increaseCountResendOtp,
  setOtpMethod,
) => {
  setShowOtpInput(false)
  const auth = getFirebaseAuth()

  // Clean up any existing reCAPTCHA verifier
  if (globalRecaptchaVerifier) {
    try {
      globalRecaptchaVerifier.clear()
    } catch (e) {
      // Ignore cleanup errors
    }
    globalRecaptchaVerifier = null
  }
  
  // Clear the container
  const container = document.getElementById('recaptcha-container')
  if (container) {
    container.innerHTML = ''
  }
  
  // Firebase v11+ requires initializing reCAPTCHA config before phone auth
  try {
    await initializeRecaptchaConfig(auth)
  } catch (configError) {
    // Config initialization can fail but phone auth may still work
  }
  
  const CaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', { 'size': 'invisible' })
  globalRecaptchaVerifier = CaptchaVerifier
  
  try {
    const confirmationResult = await signInWithPhoneNumber(auth, number, CaptchaVerifier)
    // SMS sent successfully
    resetSecondsTimeout()
    increaseCountResendOtp()
    setShowOtpInput(true)
    setMobileNumberInputDisabled(false)
    setConfirmationResultMobileLogin(confirmationResult)
    if (setOtpMethod) setOtpMethod('sms')
    return confirmationResult
  } catch (error) {
    // Error; SMS not sent
    console.error('Error sending OTP:', error)
    setErrorText(parseFirebaseError(error))
  }
}

const verifyOtp = async (
  otp,
  confirmationResultMobileLogin,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
  beforeReloadFunction,
  redirectToURI,
) => {
  try {
    const response = await confirmationResultMobileLogin.confirm(otp)
    const firebaseIdToken = await response.user.getIdToken()
    const res = await verifyLogin(firebaseIdToken)
    handleAfterLoginCAMC(
      res,
      setErrorText,
      doBasicOnboardingInside,
      setBasicOnboardingFlowVisible,
      setProfileDataForBasicOnboarding,
      beforeReloadFunction,
      redirectToURI,
    )
  } catch (err) {
    setErrorText('Invalid OTP! Please check again')
  }
}

const resolveRetryAfterSeconds = (payload, fallback = 60) => {
  if (!payload) {
    return fallback
  }
  const retryAfter = Number(payload.retryAfter)
  if (Number.isFinite(retryAfter) && retryAfter > 0) {
    return retryAfter
  }
  if (payload.resendAvailableAt) {
    const resendTime = new Date(payload.resendAvailableAt).getTime()
    if (!Number.isNaN(resendTime)) {
      return Math.max(1, Math.ceil((resendTime - Date.now()) / 1000))
    }
  }
  return fallback
}

/**
 * Send OTP to WhatsApp number (independent of Firebase)
 */
const sendWhatsAppOtpRequest = async (
  whatsappNumber,
  setShowOtpInput,
  setErrorText,
  setMobileNumberInputDisabled,
  setWhatsappSessionId,
  setWhatsappOtpExpiry,
  setWhatsappOtpCountdown,
  setWhatsappResendCountdown,
  setOtpMethod,
) => {
  try {
    const response = await sendWhatsAppOtp(whatsappNumber)
    if (response?.status === 200 && response?.data?.success) {
      const otpExpiry = response.data.otpExpiry || 300
      const resendDelay = resolveRetryAfterSeconds(response.data, 60)
      setShowOtpInput(true)
      setMobileNumberInputDisabled(false)
      setWhatsappSessionId(response.data.sessionId)
      setWhatsappOtpExpiry(otpExpiry)
      setWhatsappOtpCountdown(otpExpiry) // Start countdown with actual expiry time
      setWhatsappResendCountdown(resendDelay)
      setOtpMethod('whatsapp')
      toast.success(response.data.message || 'Code sent successfully to WhatsApp')
      return response.data
    } else {
      const errorData = response?.response?.data || response?.data || {}
      const errorCode = errorData.errorCode
      let errorMessage = errorData.message || 'Failed to send code'
      
      // Handle specific error codes according to documentation
      if (errorCode === 'INVALID_NUMBER_FORMAT') {
        errorMessage = 'Please enter a valid WhatsApp number in international format (e.g., +919876543210)'
      } else if (errorCode === 'NUMBER_NOT_FOUND') {
        errorMessage = 'WhatsApp number not registered. Please use email/password or other login methods.'
      } else if (errorCode === 'RATE_LIMIT_EXCEEDED') {
        const retryAfter = resolveRetryAfterSeconds(errorData, 60)
        errorMessage = `Too many OTP requests. Please try again after ${retryAfter} seconds.`
        setWhatsappResendCountdown(retryAfter)
      }
      
      setErrorText(errorMessage)
      return Promise.reject(new Error(errorMessage))
    }
  } catch (error) {
    const errorData = error?.response?.data || {}
    const errorCode = errorData.errorCode
    let errorMessage = errorData.message || 'Error sending code to WhatsApp'
    
    // Handle specific error codes
    if (error?.response?.status === 429 || errorCode === 'RATE_LIMIT_EXCEEDED') {
      const retryAfter = resolveRetryAfterSeconds(errorData, 60)
      errorMessage = `Too many OTP requests. Please try again after ${retryAfter} seconds.`
      setWhatsappResendCountdown(retryAfter)
    } else if (errorCode === 'INVALID_NUMBER_FORMAT') {
      errorMessage = 'Please enter a valid WhatsApp number in international format (e.g., +919876543210)'
    } else if (errorCode === 'NUMBER_NOT_FOUND') {
      errorMessage = 'WhatsApp number not registered. Please use email/password or other login methods.'
    }
    
    setErrorText(errorMessage)
    return Promise.reject(error)
  }
}

/**
 * Verify WhatsApp OTP and get access token
 */
const verifyWhatsAppOtpRequest = async (
  whatsappNumber,
  otp,
  sessionId,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
  beforeReloadFunction,
  redirectToURI,
  setShowOtpInput,
) => {
  try {
    const response = await verifyWhatsAppOtp(whatsappNumber, otp, sessionId)
    if (response?.status === 200) {
      // Response contains accessToken, authorities, accessTokenExpiry directly
      handleAfterLoginCAMC(
        response,
        setErrorText,
        doBasicOnboardingInside,
        setBasicOnboardingFlowVisible,
        setProfileDataForBasicOnboarding,
        beforeReloadFunction,
        redirectToURI,
      )
    } else {
      const errorData = response?.response?.data || response?.data || {}
      const errorCode = errorData.errorCode
      let errorMessage = errorData.message || 'Invalid OTP'
      
      // Handle specific error codes according to documentation
      if (errorCode === 'INVALID_OTP') {
        errorMessage = 'Invalid OTP. Please check and try again'
      } else if (errorCode === 'OTP_EXPIRED') {
        errorMessage = 'OTP has expired. Please request a new OTP'
        setShowOtpInput(false) // Reset to request new OTP
      } else if (errorCode === 'SESSION_NOT_FOUND') {
        errorMessage = 'Session expired. Please request a new OTP'
        setShowOtpInput(false) // Reset to request new OTP
      } else if (errorCode === 'MAX_ATTEMPTS_EXCEEDED') {
        errorMessage = 'Too many verification attempts. Please request a new OTP'
        setShowOtpInput(false) // Reset to request new OTP
      }
      
      setErrorText(errorMessage)
    }
  } catch (err) {
    const errorData = err?.response?.data || {}
    const errorCode = errorData.errorCode
    let errorMessage = errorData.message || 'Invalid OTP! Please check again'
    
    // Handle specific error codes
    if (err?.response?.status === 401 || errorCode === 'OTP_EXPIRED') {
      errorMessage = 'OTP has expired. Please request a new OTP'
      setShowOtpInput(false)
    } else if (err?.response?.status === 400 && errorCode === 'INVALID_OTP') {
      errorMessage = 'Invalid OTP. Please check and try again'
    } else if (err?.response?.status === 404 || errorCode === 'SESSION_NOT_FOUND') {
      errorMessage = 'Session expired. Please request a new OTP'
      setShowOtpInput(false)
    } else if (err?.response?.status === 429 || errorCode === 'MAX_ATTEMPTS_EXCEEDED') {
      errorMessage = 'Too many verification attempts. Please request a new OTP'
      setShowOtpInput(false)
    }
    
    setErrorText(errorMessage)
  }
}

const sendEmailOtpRequest = async (
  email,
  setShowEmailOtpInput,
  setErrorText,
  setEmailOtpSessionId,
  setEmailOtpExpiry,
  setEmailOtpCountdown,
  setEmailResendCountdown,
  emailOtpSendInFlightRef,
) => {
  if (emailOtpSendInFlightRef?.current) {
    return Promise.reject(new Error('email_code_request_in_flight'))
  }
  if (emailOtpSendInFlightRef) {
    emailOtpSendInFlightRef.current = true
  }
  try {
    const response = await sendEmailLoginOtp(email)
    if (response?.status === 200 && response?.data?.success) {
      const otpExpiry = response.data.otpExpiry || 300
      const resendDelay = resolveRetryAfterSeconds(response.data, 60)
      setShowEmailOtpInput(true)
      setEmailOtpSessionId(response.data.sessionId)
      setEmailOtpExpiry(otpExpiry)
      setEmailOtpCountdown(otpExpiry)
      setEmailResendCountdown(resendDelay)
      toast.success(response.data.message || 'Code sent successfully to your email')
      return response.data
    }

    const errorData = response?.response?.data || response?.data || {}
    const retryAfter = resolveRetryAfterSeconds(errorData, 60)
    const errorCode = errorData.errorCode
    let errorMessage = errorData.message || 'Failed to send code'

    if (errorCode === 'INVALID_EMAIL_FORMAT') {
      errorMessage = 'Please enter a valid email address.'
    } else if (errorCode === 'EMAIL_NOT_FOUND') {
      errorMessage = 'Email address not registered. Please sign in with your password or use another method.'
    } else if (errorCode === 'RATE_LIMIT_EXCEEDED') {
      errorMessage = `Too many code requests. Please try again after ${retryAfter} seconds.`
      setEmailResendCountdown(retryAfter)
    }

    setErrorText(errorMessage)
    return Promise.reject(new Error(errorMessage))
  } catch (error) {
    const errorData = error?.response?.data || {}
    const retryAfter = resolveRetryAfterSeconds(errorData, 60)
    const errorCode = errorData.errorCode
    let errorMessage = errorData.message || 'Error sending code to your email'

    if (error?.response?.status === 429 || errorCode === 'RATE_LIMIT_EXCEEDED') {
      errorMessage = `Too many code requests. Please try again after ${retryAfter} seconds.`
      setEmailResendCountdown(retryAfter)
    } else if (errorCode === 'INVALID_EMAIL_FORMAT') {
      errorMessage = 'Please enter a valid email address.'
    } else if (errorCode === 'EMAIL_NOT_FOUND') {
      errorMessage = 'Email address not registered. Please sign in with your password or use another method.'
    }

    setErrorText(errorMessage)
    return Promise.reject(error)
  } finally {
    if (emailOtpSendInFlightRef) {
      emailOtpSendInFlightRef.current = false
    }
  }
}

const verifyEmailOtpRequest = async (
  email,
  otp,
  sessionId,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
  beforeReloadFunction,
  redirectToURI,
  setShowEmailOtpInput,
) => {
  try {
    const response = await verifyEmailLoginOtp(email, otp, sessionId)
    if (response?.status === 200) {
      handleAfterLoginCAMC(
        response,
        setErrorText,
        doBasicOnboardingInside,
        setBasicOnboardingFlowVisible,
        setProfileDataForBasicOnboarding,
        beforeReloadFunction,
        redirectToURI,
      )
      return
    }

    const errorData = response?.response?.data || response?.data || {}
    const errorCode = errorData.errorCode
    let errorMessage = errorData.message || 'Invalid OTP'

    if (errorCode === 'INVALID_OTP') {
      errorMessage = 'Invalid OTP. Please check and try again.'
    } else if (errorCode === 'OTP_EXPIRED') {
      errorMessage = 'OTP has expired. Please request a new code.'
      setShowEmailOtpInput(false)
    } else if (errorCode === 'SESSION_NOT_FOUND') {
      errorMessage = 'Session expired. Please request a new code.'
      setShowEmailOtpInput(false)
    } else if (errorCode === 'MAX_ATTEMPTS_EXCEEDED') {
      errorMessage = 'Too many verification attempts. Please request a new code.'
      setShowEmailOtpInput(false)
    }

    setErrorText(errorMessage)
  } catch (err) {
    const errorData = err?.response?.data || {}
    const errorCode = errorData.errorCode
    let errorMessage = errorData.message || 'Invalid OTP! Please check again.'

    if (err?.response?.status === 401 || errorCode === 'OTP_EXPIRED') {
      errorMessage = 'OTP has expired. Please request a new code.'
      setShowEmailOtpInput(false)
    } else if (err?.response?.status === 400 && errorCode === 'INVALID_OTP') {
      errorMessage = 'Invalid OTP. Please check and try again.'
    } else if (err?.response?.status === 404 || errorCode === 'SESSION_NOT_FOUND') {
      errorMessage = 'Session expired. Please request a new code.'
      setShowEmailOtpInput(false)
    } else if (err?.response?.status === 429 || errorCode === 'MAX_ATTEMPTS_EXCEEDED') {
      errorMessage = 'Too many verification attempts. Please request a new code.'
      setShowEmailOtpInput(false)
    }

    setErrorText(errorMessage)
  }
}

/**
 * Get emoji flag for country code as fallback
 */
const getEmojiFlag = (countryCode) => {
  if (!countryCode || countryCode.length !== 2) return null
  
  // Convert country code to emoji flag
  // Each letter is converted to its regional indicator symbol
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0))
  
  return String.fromCodePoint(...codePoints)
}

/////////////////////////////////////////// MAIN THING :

export function ClubbedAuthMainComponent({
  theme,
  doBasicOnboardingInside = false,
  loginVariant,
  nameFieldHeading = 'Name',
  loginFieldHeading = 'Log in',
  preferredLoginInputType = 'mobile',
  preferredLoginInputValue,
  beforeReloadFunction,
  redirectToURI,
  initialOnboardingDetails = INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE,
}) {
  const navigate = useNavigate()
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [basicOnboardingFlowVisible, setBasicOnboardingFlowVisible] = useState(false)
  const [authType, setAuthType] = useState(loginVariant ? 'login' : 'signup')
  const [activeInputType, setActiveInputType] = useState() // email, mobile
  const [inputEmailPassword, setInputEmailPassword] = useState({ email: '', password: '' })
  const [inputMobileNumber, setInputMobileNumber] = useState()
  const [showOtpInput, setShowOtpInput] = useState(false)
  const [showEmailOtpInput, setShowEmailOtpInput] = useState(false)
  // True while the email-OTP send API is still in flight. Lets us flip
  // to the OTP input UI immediately on "Email me a code instead" so the
  // user doesn't see the modal "hang" on a disabled password field, and
  // we surface "Sending code…" inline instead.
  const [emailOtpSending, setEmailOtpSending] = useState(false)
  const [inputOtp, setInputOtp] = useState()
  const [otpMethod, setOtpMethod] = useState(null) // 'sms' or 'whatsapp' - tracks which method was used
  const [resendOtpAttempts, setResendOtpAttempts] = useState(0)
  const [secondsTimeOut, setSecondsTimeOut] = useState(20) // For SMS resend cooldown
  const [whatsappOtpCountdown, setWhatsappOtpCountdown] = useState(0) // For WhatsApp OTP expiry countdown
  const [whatsappResendCountdown, setWhatsappResendCountdown] = useState(0)
  const [confirmationResultMobileLogin, setConfirmationResultMobileLogin] = useState()
  const [whatsappSessionId, setWhatsappSessionId] = useState(null)
  const [whatsappOtpExpiry, setWhatsappOtpExpiry] = useState(300)
  const [emailOtpSessionId, setEmailOtpSessionId] = useState(null)
  const [emailOtpExpiry, setEmailOtpExpiry] = useState(300)
  const [emailOtpCountdown, setEmailOtpCountdown] = useState(0)
  const [emailResendCountdown, setEmailResendCountdown] = useState(0)
  const [passwordInputType, setPasswordInputType] = useState('password')
  const [errorText, setErrorText] = useState(null)
  const [userInputsDisabled, setUserInputsDisabled] = useState(false)
  const [mobileNumberInputDisabled, setMobileNumberInputDisabled] = useState(false)
  const [sendingOtpMethod, setSendingOtpMethod] = useState(null) // 'sms' or 'whatsapp' or null
  const [selectedCountryCode, setSelectedCountryCode] = useState(localStorage.getItem('countryCode')?.toLowerCase() || 'in')
  // Secondary auth methods (Google / email switcher) are always exposed
  // so the user can see every option at a glance. Keeping this as state
  // (always true) rather than deleting the flag avoids downstream churn.
  const [useOtherMethods] = useState(true)

  const [profileDataForBasicOnboarding, setProfileDataForBasicOnboarding] = useState()
  const [basicOnboardingDetails, setBasicOnboardingDetails] = useState(initialOnboardingDetails)
  const [basicOnboardingErrorText, setBasicOnboardingErrorText] = useState()
  const [basicOnboardingLoading, setBasicOnboardingLoading] = useState(false)
  const [proceedingToLogin, setProceedingToLogin] = useState(false)
  const isSmallScreen = useMediaQuery('(max-width: 400px)')
  const emailInputRef = useRef(null)
  const passwordInputRef = useRef(null)
  const emailOtpSendInFlightRef = useRef(false)

  const getSubmittedEmailPassword = () => {
    const emailValue =
      typeof emailInputRef.current?.value === 'string'
        ? emailInputRef.current.value
        : inputEmailPassword.email
    const passwordValue =
      typeof passwordInputRef.current?.value === 'string'
        ? passwordInputRef.current.value
        : inputEmailPassword.password

    return {
      email: emailValue.trim(),
      password: passwordValue,
    }
  }

  useEffect(() => {
    // Only run once when loginPolicy becomes available (and activeInputType not yet set)
    if (!unSecureSetupData?.loginPolicy?.login || activeInputType) {
      return
    }

    // Prefill from any preferredLoginInputValue the caller passed in.
    const applyMobilePrefill = () => {
      if (preferredLoginInputValue && typeof preferredLoginInputValue === 'string') {
        setInputMobileNumber(
          preferredLoginInputValue.startsWith('+')
            ? preferredLoginInputValue.slice(1)
            : preferredLoginInputValue,
        )
      }
    }
    const applyEmailPrefill = () => {
      if (preferredLoginInputValue && isValidEmail(preferredLoginInputValue)) {
        setInputEmailPassword({ ...inputEmailPassword, email: preferredLoginInputValue })
      }
    }

    if (preferredLoginInputType === 'mobile' || preferredLoginInputType === 'whatsapp') {
      if (unSecureSetupData.loginPolicy.login.mobile) {
        applyMobilePrefill()
        setActiveInputType('mobile')
        return
      }
      if (unSecureSetupData.loginPolicy.login.usernamePassword) {
        setActiveInputType('email')
        return
      }
    }

    if (preferredLoginInputType === 'email') {
      if (unSecureSetupData.loginPolicy.login.usernamePassword) {
        applyEmailPrefill()
        setActiveInputType('email')
        return
      }
      if (unSecureSetupData.loginPolicy.login.mobile) {
        setActiveInputType('mobile')
        return
      }
    }

    // No preferred type supplied — prefer mobile (WhatsApp/SMS) since that's
    // the fastest path to auth for most users, falling back to email/password.
    if (unSecureSetupData.loginPolicy.login.mobile) {
      setActiveInputType('mobile')
    } else if (unSecureSetupData.loginPolicy.login.usernamePassword) {
      setActiveInputType('email')
    }
  }, [unSecureSetupData?.loginPolicy?.login]) // eslint-disable-line react-hooks/exhaustive-deps

  function resetTogether() {
    setErrorText(null)
    setInputOtp()
    setShowOtpInput(false)
    setShowEmailOtpInput(false)
    setEmailOtpSending(false)
    setOtpMethod(null)
    setSendingOtpMethod(null)
    setWhatsappSessionId(null)
    setWhatsappOtpCountdown(0)
    setWhatsappResendCountdown(0)
    setEmailOtpSessionId(null)
    setEmailOtpCountdown(0)
    setEmailResendCountdown(0)
    setMobileNumberInputDisabled(false)
  }

  // Countdown timer for SMS resend cooldown
  useEffect(() => {
    const interval = setInterval(() => {
      if (secondsTimeOut > 0 && showOtpInput && otpMethod === 'sms') {
        setSecondsTimeOut((prev) => prev - 1)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [secondsTimeOut, showOtpInput, otpMethod])

  // Countdown timer for WhatsApp OTP expiry
  useEffect(() => {
    if (whatsappOtpCountdown > 0 && showOtpInput && otpMethod === 'whatsapp') {
      const interval = setInterval(() => {
        setWhatsappOtpCountdown((prev) => {
          if (prev <= 1) {
            return 0
          }
          return prev - 1
        })
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [whatsappOtpCountdown, showOtpInput, otpMethod])

  useEffect(() => {
    if (whatsappResendCountdown > 0 && showOtpInput && otpMethod === 'whatsapp') {
      const interval = setInterval(() => {
        setWhatsappResendCountdown((prev) => {
          if (prev <= 1) {
            return 0
          }
          return prev - 1
        })
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [whatsappResendCountdown, showOtpInput, otpMethod])

  useEffect(() => {
    if (emailOtpCountdown > 0 && showEmailOtpInput) {
      const interval = setInterval(() => {
        setEmailOtpCountdown((prev) => {
          if (prev <= 1) {
            return 0
          }
          return prev - 1
        })
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [emailOtpCountdown, showEmailOtpInput])

  useEffect(() => {
    if (emailResendCountdown > 0 && showEmailOtpInput) {
      const interval = setInterval(() => {
        setEmailResendCountdown((prev) => {
          if (prev <= 1) {
            return 0
          }
          return prev - 1
        })
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [emailResendCountdown, showEmailOtpInput])

  // Fix phone input dropdown z-index and flag overlap issues, and improve flag quality
  useEffect(() => {
    if (activeInputType === 'mobile') {
      const fixPhoneInputIssues = () => {
        // Fix country list z-index
        const countryLists = document.querySelectorAll('.country-list')
        countryLists.forEach((list) => {
          if (list && list.parentElement) {
            list.style.zIndex = '99999'
            // Ensure parent containers allow overflow
            let parent = list.parentElement
            while (parent && parent !== document.body) {
              if (getComputedStyle(parent).overflow === 'hidden') {
                parent.style.overflow = 'visible'
              }
              parent = parent.parentElement
            }
          }
        })
        
        // Fix flag overlap and improve quality - replace CSS sprites with high-quality images
        const selectedFlags = document.querySelectorAll('.selected-flag')
        selectedFlags.forEach((flagContainer) => {
          const flags = flagContainer.querySelectorAll('.flag')
          if (flags.length > 1) {
            // Hide all except the first one
            flags.forEach((flag, index) => {
              if (index > 0) {
                flag.style.display = 'none'
                flag.style.visibility = 'hidden'
                flag.style.opacity = '0'
                flag.style.position = 'absolute'
                flag.style.zIndex = '-1'
              } else {
                flag.style.display = 'inline-block'
                flag.style.visibility = 'visible'
                flag.style.opacity = '1'
                flag.style.position = 'relative'
                flag.style.zIndex = '2'
                
                // Replace CSS sprite with high-quality PNG flags from flagcdn.com
                // Use the tracked country code or extract from flag element
                let countryCode = selectedCountryCode
                
                // Try to extract from flag element attributes
                if (!countryCode) {
                  countryCode = flag.getAttribute('data-country-code') || 
                               flag.getAttribute('title')?.toLowerCase() ||
                               flag.className.match(/flag-([a-z]{2})/)?.[1] ||
                               localStorage.getItem('countryCode')?.toLowerCase() || 'in'
                }
                
                // Completely remove CSS sprite first
                flag.style.backgroundImage = 'none'
                flag.style.backgroundPosition = 'unset'
                flag.style.backgroundSize = 'unset'
                
                // Create an img element for better loading control and fallback
                if (countryCode && !flag.querySelector('img.flag-img') && !flag.dataset.flagProcessed) {
                  flag.dataset.flagProcessed = 'true' // Mark as processed to avoid duplicates
                  
                  const img = document.createElement('img')
                  img.className = 'flag-img'
                  img.alt = countryCode.toUpperCase()
                  img.style.width = '20px'
                  img.style.height = '15px'
                  img.style.objectFit = 'contain'
                  img.style.display = 'inline-block'
                  img.style.verticalAlign = 'middle'
                  
                  // Use lazy loading for non-critical flags (dropdown flags)
                  // For selected flag, load immediately
                  const isSelectedFlag = flag.closest('.selected-flag')
                  img.loading = isSelectedFlag ? 'eager' : 'lazy'
                  
                  // Fallback to emoji flag if image fails to load
                  img.onerror = () => {
                    img.style.display = 'none'
                    const emojiFlag = getEmojiFlag(countryCode)
                    if (emojiFlag) {
                      flag.textContent = emojiFlag
                      flag.style.fontSize = '20px'
                      flag.style.lineHeight = '15px'
                      flag.style.display = 'inline-block'
                    } else {
                      // Final fallback: show country code
                      flag.textContent = countryCode.toUpperCase()
                      flag.style.fontSize = '10px'
                      flag.style.fontWeight = 'bold'
                    }
                  }
                  
                  // Set src after error handler is attached
                  img.src = `https://flagcdn.com/w40/${countryCode}.png`
                  
                  // Clear any existing content and add the image
                  flag.innerHTML = ''
                  flag.appendChild(img)
                }
              }
            })
          } else if (flags.length === 1) {
            // Single flag - improve quality
            const flag = flags[0]
            let countryCode = selectedCountryCode || 
                             flag.getAttribute('data-country-code') || 
                             flag.getAttribute('title')?.toLowerCase() ||
                             flag.className.match(/flag-([a-z]{2})/)?.[1] ||
                             localStorage.getItem('countryCode')?.toLowerCase() || 'in'
            
            // Completely remove CSS sprite
            flag.style.backgroundImage = 'none'
            flag.style.backgroundPosition = 'unset'
            flag.style.backgroundSize = 'unset'
            
            // Create img element if not already present
            if (countryCode && !flag.querySelector('img.flag-img') && !flag.dataset.flagProcessed) {
              flag.dataset.flagProcessed = 'true'
              
              const img = document.createElement('img')
              img.className = 'flag-img'
              img.alt = countryCode.toUpperCase()
              img.style.width = '20px'
              img.style.height = '15px'
              img.style.objectFit = 'contain'
              img.style.display = 'inline-block'
              img.style.verticalAlign = 'middle'
              img.loading = 'eager' // Selected flag loads immediately
              
              img.onerror = () => {
                img.style.display = 'none'
                const emojiFlag = getEmojiFlag(countryCode)
                if (emojiFlag) {
                  flag.textContent = emojiFlag
                  flag.style.fontSize = '20px'
                  flag.style.lineHeight = '15px'
                  flag.style.display = 'inline-block'
                } else {
                  flag.textContent = countryCode.toUpperCase()
                  flag.style.fontSize = '10px'
                  flag.style.fontWeight = 'bold'
                }
              }
              
              img.src = `https://flagcdn.com/w40/${countryCode}.png`
              flag.innerHTML = ''
              flag.appendChild(img)
            }
          }
          
          // Fix arrow overlap
          const arrows = flagContainer.querySelectorAll('.arrow, .arrow-up, [class*="arrow"]')
          if (arrows.length > 1) {
            arrows.forEach((arrow, index) => {
              if (index < arrows.length - 1) {
                arrow.style.display = 'none'
                arrow.style.visibility = 'hidden'
                arrow.style.opacity = '0'
                arrow.style.position = 'absolute'
                arrow.style.zIndex = '-1'
              } else {
                arrow.style.display = 'inline-block'
                arrow.style.visibility = 'visible'
                arrow.style.opacity = '1'
                arrow.style.position = 'relative'
                arrow.style.zIndex = '2'
              }
            })
          }
        })
        
        // Also improve flags in dropdown - extract country code from country element
        const dropdownCountries = document.querySelectorAll('.country-list .country')
        dropdownCountries.forEach((countryElement) => {
          const flag = countryElement.querySelector('.flag')
          if (!flag || flag.querySelector('img.flag-img')) return // Skip if already processed
          
          // Extract country code from country element's data attributes
          let countryCode = countryElement.getAttribute('data-country-code') ||
                           countryElement.getAttribute('data-dial-code')?.toLowerCase()
          
          // Try to get from dial code element or className
          if (!countryCode) {
            const countryMatch = countryElement.className.match(/country-([a-z]{2})/i) ||
                                countryElement.className.match(/flag-([a-z]{2})/i)
            countryCode = countryMatch?.[1]?.toLowerCase()
          }
          
          // Try to extract from flag class name as last resort
          if (!countryCode) {
            countryCode = flag.className.match(/flag-([a-z]{2})/)?.[1]
          }
          
          if (countryCode && !flag.querySelector('img.flag-img') && !flag.dataset.flagProcessed) {
            flag.dataset.flagProcessed = 'true'
            
            // Remove CSS sprite completely
            flag.style.backgroundImage = 'none'
            flag.style.backgroundPosition = 'unset'
            flag.style.backgroundSize = 'unset'
            
            // Create img element with lazy loading for dropdown
            const img = document.createElement('img')
            img.className = 'flag-img'
            img.alt = countryCode.toUpperCase()
            img.style.width = '20px'
            img.style.height = '15px'
            img.style.objectFit = 'contain'
            img.style.display = 'inline-block'
            img.style.verticalAlign = 'middle'
            img.style.marginRight = '8px'
            img.loading = 'lazy' // Lazy load dropdown flags
            
            img.onerror = () => {
              img.style.display = 'none'
              const emojiFlag = getEmojiFlag(countryCode)
              if (emojiFlag) {
                flag.textContent = emojiFlag
                flag.style.fontSize = '20px'
                flag.style.lineHeight = '15px'
                flag.style.display = 'inline-block'
              } else {
                flag.textContent = countryCode.toUpperCase()
                flag.style.fontSize = '10px'
                flag.style.fontWeight = 'bold'
              }
            }
            
            img.src = `https://flagcdn.com/w40/${countryCode}.png`
            flag.innerHTML = ''
            flag.appendChild(img)
          }
        })
      }

      // Use MutationObserver to watch for changes
      const observer = new MutationObserver(() => {
        fixPhoneInputIssues()
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      })

      // Also check immediately and on interval
      fixPhoneInputIssues()
      const interval = setInterval(fixPhoneInputIssues, 200)

      return () => {
        observer.disconnect()
        clearInterval(interval)
      }
    }
  }, [activeInputType])

  async function handleNext(doBasicOnboardingInside) {
    setErrorText(null)
    setProceedingToLogin(false)
    setUserInputsDisabled(true)
    const submittedEmailPassword =
      activeInputType === 'email' ? getSubmittedEmailPassword() : inputEmailPassword

    if (activeInputType === 'email') {
      setInputEmailPassword(submittedEmailPassword)
    }

    if (authType === 'signup' && activeInputType === 'email') {
      if (validateEmail(submittedEmailPassword.email)) {
        if (submittedEmailPassword.password.length >= 6) {
          const payload = prepareDataForRegistration(submittedEmailPassword)
          const response = await postData('/api/user/registration', payload)
          
          // Check for code 9000 or 4004 (user already registered)
          // When postData catches an error, it returns the error object which has response.response.data
          // When successful, it returns the axios response which has response.data
          const errorCode = response?.response?.data?.code || response?.data?.code
          if (errorCode === 9000 || errorCode === 4004) {
            const errorMessage = response?.response?.data?.message || response?.data?.message || 'User already registered'
            setErrorText(errorMessage)
            setProceedingToLogin(true)
            setUserInputsDisabled(false)
            
            // Wait a moment to show the message, then attempt login
            setTimeout(async () => {
              setUserInputsDisabled(true)
              const loginResponse = await SignIn(submittedEmailPassword.email, submittedEmailPassword.password)
              await handleAfterLoginCAMC(
                loginResponse,
                setErrorText,
                doBasicOnboardingInside,
                setBasicOnboardingFlowVisible,
                setProfileDataForBasicOnboarding,
                beforeReloadFunction,
                redirectToURI,
              )
              setUserInputsDisabled(false)
            }, 1500)
            return null
          }
          
          handleAfterLoginCAMC(
            response,
            setErrorText,
            doBasicOnboardingInside,
            setBasicOnboardingFlowVisible,
            setProfileDataForBasicOnboarding,
            beforeReloadFunction,
            redirectToURI,
          )
        } else {
          setErrorText('Password should contain at least 6 digits')
          setUserInputsDisabled(false)
          return null
        }
      } else {
        setErrorText('Please enter a valid email address')
        setUserInputsDisabled(false)
        return null
      }
    } else if (authType === 'login' && activeInputType === 'email') {
      if (showEmailOtpInput) {
        if (!inputOtp?.length) {
          setErrorText('Please enter the code received on your email')
          setUserInputsDisabled(false)
          return null
        }
        if (!emailOtpSessionId) {
          setErrorText('Session expired. Please request a new code')
          setShowEmailOtpInput(false)
          setUserInputsDisabled(false)
          return null
        }
        await verifyEmailOtpRequest(
          submittedEmailPassword.email,
          inputOtp,
          emailOtpSessionId,
          setErrorText,
          doBasicOnboardingInside,
          setBasicOnboardingFlowVisible,
          setProfileDataForBasicOnboarding,
          beforeReloadFunction,
          redirectToURI,
          setShowEmailOtpInput,
        )
      } else {
        const response = await SignIn(submittedEmailPassword.email, submittedEmailPassword.password)
        await handleAfterLoginCAMC(
          response,
          setErrorText,
          doBasicOnboardingInside,
          setBasicOnboardingFlowVisible,
          setProfileDataForBasicOnboarding,
          beforeReloadFunction,
          redirectToURI,
        )
      }
    } else if (activeInputType === 'mobile' && showOtpInput) {
      if (!inputOtp?.length) {
        setErrorText(`Please enter the code received via ${otpMethod === 'whatsapp' ? 'WhatsApp' : 'SMS'}`)
        setUserInputsDisabled(false)
        return null
      } else {
        if (otpMethod === 'whatsapp') {
          if (!whatsappSessionId) {
            setErrorText('Session expired. Please request a new code')
            setShowOtpInput(false)
            setUserInputsDisabled(false)
            return null
          }
          await verifyWhatsAppOtpRequest(
            `+${inputMobileNumber}`,
            inputOtp,
            whatsappSessionId,
            setErrorText,
            doBasicOnboardingInside,
            setBasicOnboardingFlowVisible,
            setProfileDataForBasicOnboarding,
            beforeReloadFunction,
            redirectToURI,
            setShowOtpInput,
          )
        } else {
          await verifyOtp(
            inputOtp,
            confirmationResultMobileLogin,
            setErrorText,
            doBasicOnboardingInside,
            setBasicOnboardingFlowVisible,
            setProfileDataForBasicOnboarding,
            beforeReloadFunction,
            redirectToURI,
          )
        }
      }
    }
    setUserInputsDisabled(false)
  }

  async function handleNextBasicOnboarding(profileData) {
    setBasicOnboardingErrorText(null)
    setBasicOnboardingLoading(true)
    if (basicOnboardingDetails?.name?.length > 0) {
      if (basicOnboardingDetails.age >= 12 && basicOnboardingDetails.age <= 120) {
        const payload = prepareDataForUpdate(basicOnboardingDetails, profileData)
        const response = await postData('/api/secure/user/update', payload)
        if (response.status === 200) {
          beforeReloadFunction && beforeReloadFunction()
          if (redirectToURI) {
            window.location.href = decodeURIComponent(redirectToURI)
          } else {
            window.location.reload()
          }
        } else {
          beforeReloadFunction && beforeReloadFunction()
          if (redirectToURI) {
            window.location.href = decodeURIComponent(redirectToURI)
          } else {
            window.location.reload()
          }
        }
      } else {
        setBasicOnboardingErrorText('You must be 12-120 to use AUMHUM')
        setBasicOnboardingLoading(false)
      }
    } else {
      setBasicOnboardingErrorText('Please enter your name')
      setBasicOnboardingLoading(false)
    }
    setBasicOnboardingLoading(false)
  }

  const resetSecondsTimeout = () => setSecondsTimeOut(20)
  const increaseCountResendOtp = () => setResendOtpAttempts((prev) => prev + 1)

  // Show loading state if login methods not yet loaded
  const isLoadingMethods = !unSecureSetupData?.loginPolicy?.login && !activeInputType

  return (
    <CAMCParent>
      {!basicOnboardingFlowVisible && (
        <>
          <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <CAMCHeading>
              {authType === 'signup' ? 'Create your AUMHUM account' : loginFieldHeading || 'Welcome back'}
            </CAMCHeading>
            <div style={{ fontSize: '14px', color: '#64748b' }}>
              {authType === 'signup'
                ? 'Sign up with your mobile number in a few seconds.'
                : 'Sign in to continue your clinical care.'}
            </div>
          </div>

          {/* Loading state when methods not loaded yet */}
          {isLoadingMethods && (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'center',
              padding: '40px 20px',
              gap: '16px'
            }}>
              <Spinner animation="border" style={{ color: '#514387', width: '32px', height: '32px' }} />
              <span style={{ 
                color: '#707070', 
                fontSize: '14px',
                fontFamily: "'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
              }}>
                Loading login options...
              </span>
            </div>
          )}

          {activeInputType === 'email' && (
            <>
              <CAMCMaxWithRelativeContainer>
                <CAMCGeneralInputLabel htmlFor="email">Email address</CAMCGeneralInputLabel>
                <CAMCMaxWithRelativeContainer>
                  <CAMCGeneralInput
                    id="email"
                    type="text"
                    name="email"
                    value={inputEmailPassword?.email}
                    ref={emailInputRef}
                    disabled={userInputsDisabled}
                    autoComplete={authType === 'login' ? 'username' : 'email'}
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    inputMode="email"
                    onChange={(e) =>
                      setInputEmailPassword((prev) => ({ ...prev, email: e.target.value }))
                    }
                    style={{
                      paddingRight: inputEmailPassword?.email && isValidEmail(inputEmailPassword.email) ? '35px' : '7px'
                    }}
                  />
                  {inputEmailPassword?.email && isValidEmail(inputEmailPassword.email) && (
                    <span style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#25D366',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: '#ffffff',
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                      justifyContent: 'center',
                      lineHeight: '24px'
                    }}>
                      ✓
                    </span>
                  )}
                </CAMCMaxWithRelativeContainer>
              </CAMCMaxWithRelativeContainer>
              <CAMCMaxWithRelativeContainer>
                {!showEmailOtpInput ? (
                  <>
                    <CAMCGeneralInputLabel htmlFor="password">Password</CAMCGeneralInputLabel>
                    <CAMCMaxWithRelativeContainer>
                      <CAMCGeneralInput
                        id="password"
                        type={passwordInputType}
                        name="password"
                        value={inputEmailPassword?.password}
                        ref={passwordInputRef}
                        disabled={userInputsDisabled}
                        autoComplete={authType === 'login' ? 'current-password' : 'new-password'}
                        onChange={(e) =>
                          setInputEmailPassword((prev) => ({ ...prev, password: e.target.value }))
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !userInputsDisabled) {
                            e.preventDefault()
                            handleNext(doBasicOnboardingInside)
                          }
                        }}
                      />
                      {passwordInputType === 'text' ? (
                        <VisibilityOffIcon
                          sx={{
                            fontSize: 20,
                            position: 'absolute',
                            right: 5,
                            top: 11,
                            cursor: 'pointer',
                          }}
                          onClick={() => setPasswordInputType('password')}
                        />
                      ) : (
                        <VisibilityIcon
                          sx={{
                            fontSize: 20,
                            position: 'absolute',
                            right: 5,
                            top: 11,
                            cursor: 'pointer',
                          }}
                          onClick={() => setPasswordInputType('text')}
                        />
                      )}
                    </CAMCMaxWithRelativeContainer>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '12px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        style={{
                          color: '#514387',
                          fontSize: '12px',
                          textAlign: 'right',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          if (isValidEmail(inputEmailPassword?.email)) {
                            navigate(`/forgot-password?email=${inputEmailPassword?.email}`)
                          } else {
                            navigate(`/forgot-password`)
                          }
                        }}
                      >
                        Forgot password?
                      </div>
                      {authType === 'login' && (
                        <div
                          style={{
                            color: '#0f766e',
                            fontSize: '12px',
                            fontWeight: '600',
                            cursor: 'pointer',
                          }}
                          onClick={async () => {
                            if (userInputsDisabled || emailOtpSendInFlightRef.current) {
                              return
                            }
                            const submittedEmailPassword = getSubmittedEmailPassword()
                            setInputEmailPassword(submittedEmailPassword)
                            if (!isValidEmail(submittedEmailPassword.email)) {
                              setErrorText('Please enter a valid email address')
                              return
                            }
                            setErrorText(null)
                            setInputOtp('')
                            // Flip to the OTP input UI immediately so the
                            // user sees the code field + a "Sending code…"
                            // banner while the API call is in flight.
                            // sendEmailOtpRequest also calls setShowEmailOtpInput(true)
                            // on success (no-op here since we're already true).
                            setEmailOtpSending(true)
                            setShowEmailOtpInput(true)
                            setUserInputsDisabled(true)
                            try {
                              await sendEmailOtpRequest(
                                submittedEmailPassword.email,
                                setShowEmailOtpInput,
                                setErrorText,
                                setEmailOtpSessionId,
                                setEmailOtpExpiry,
                                setEmailOtpCountdown,
                                setEmailResendCountdown,
                                emailOtpSendInFlightRef,
                              )
                            } catch {
                              // Send failed — fall back to the password
                              // screen so the already-surfaced error text
                              // is next to the original inputs.
                              setShowEmailOtpInput(false)
                            } finally {
                              setEmailOtpSending(false)
                              setUserInputsDisabled(false)
                            }
                          }}
                        >
                          Email me a code instead
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <CAMCGeneralInputLabel htmlFor="email-otp">
                      Enter code from email
                    </CAMCGeneralInputLabel>
                    <div
                      style={{
                        padding: '10px',
                        background: emailOtpSending ? '#eff6ff' : '#f0fdf4',
                        borderRadius: '5px',
                        fontSize: '13px',
                        color: emailOtpSending ? '#1e40af' : '#166534',
                        marginTop: '8px',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span>{emailOtpSending ? '⏳' : '✓'}</span>
                        <span>
                          {emailOtpSending
                            ? `Sending code to ${inputEmailPassword?.email}…`
                            : `Code sent successfully to ${inputEmailPassword?.email}`}
                        </span>
                      </div>
                      <div
                        style={{
                          marginTop: '6px',
                          fontSize: '12px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span>Email login by code</span>
                        <span
                          style={{
                            color: '#514387',
                            cursor: 'pointer',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                          onClick={() => {
                            setShowEmailOtpInput(false)
                            setEmailOtpSending(false)
                            setInputOtp('')
                            setErrorText(null)
                            setEmailOtpSessionId(null)
                            setEmailOtpCountdown(0)
                            setEmailResendCountdown(0)
                          }}
                        >
                          Use password
                        </span>
                      </div>
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <OtpInput
                        value={inputOtp || ''}
                        onChange={setInputOtp}
                        numInputs={6}
                        onComplete={async (otp) => {
                          if (otp && otp.length >= 4 && !userInputsDisabled) {
                            setUserInputsDisabled(true)
                            try {
                              await verifyEmailOtpRequest(
                                inputEmailPassword?.email,
                                otp,
                                emailOtpSessionId,
                                setErrorText,
                                doBasicOnboardingInside,
                                setBasicOnboardingFlowVisible,
                                setProfileDataForBasicOnboarding,
                                beforeReloadFunction,
                                redirectToURI,
                                setShowEmailOtpInput,
                              )
                            } finally {
                              setUserInputsDisabled(false)
                            }
                          }
                        }}
                        autoFocus={true}
                        disabled={userInputsDisabled}
                        maxWidth="315px"
                        boxSize="48px"
                        mobileBoxSize="44px"
                        smallMobileBoxSize="40px"
                        fontSize="20px"
                        mobileFontSize="18px"
                        smallMobileFontSize="16px"
                        gap="8px"
                        mobileGap="6px"
                        smallMobileGap="4px"
                        background="#ffffff"
                        textColor="#242424"
                        borderColor="#707070"
                        focusBorderColor="#514387"
                        borderRadius="8px"
                      />
                    </div>
                    <CAMCResendOtpContainer>
                      {emailOtpCountdown > 0 && (
                        <div style={{ fontSize: '12px', color: '#707070', marginBottom: '8px', textAlign: 'center' }}>
                          Code expires in {Math.floor(emailOtpCountdown / 60)}:{(emailOtpCountdown % 60)
                            .toString()
                            .padStart(2, '0')}
                        </div>
                      )}
                      {emailResendCountdown > 0 ? (
                        <span data-disabled="true">Resend in {emailResendCountdown}s</span>
                      ) : (
                        <span
                          onClick={async () => {
                            if (userInputsDisabled || emailOtpSendInFlightRef.current) {
                              return
                            }
                            if (!isValidEmail(inputEmailPassword?.email)) {
                              setErrorText('Please enter a valid email address')
                              return
                            }
                            setUserInputsDisabled(true)
                            try {
                              await sendEmailOtpRequest(
                                inputEmailPassword?.email,
                                setShowEmailOtpInput,
                                setErrorText,
                                setEmailOtpSessionId,
                                setEmailOtpExpiry,
                                setEmailOtpCountdown,
                                setEmailResendCountdown,
                                emailOtpSendInFlightRef,
                              )
                            } finally {
                              setUserInputsDisabled(false)
                            }
                          }}
                        >
                          Resend code
                        </span>
                      )}
                    </CAMCResendOtpContainer>
                  </>
                )}
              </CAMCMaxWithRelativeContainer>
            </>
          )}

          {activeInputType === 'mobile' && (
            <CAMCMaxWithRelativeContainer>
              <CAMCGeneralInputLabel>
                Mobile Number {showOtpInput && `(+${inputMobileNumber})`}
              </CAMCGeneralInputLabel>
              {!showOtpInput ? (
                <>
                  <CAMCMaxWithRelativeContainer>
                    <CAMCPhoneInput
                      disabled={mobileNumberInputDisabled}
                      specialLabel=""
                      placeholder="Enter mobile number"
                      country={selectedCountryCode}
                      value={inputMobileNumber}
                      onChange={(value, data) => {
                        setInputMobileNumber(value)
                        // Extract country code from data object or parse from phone number
                        if (data && data.countryCode) {
                          setSelectedCountryCode(data.countryCode.toLowerCase())
                        } else if (data && data.country) {
                          setSelectedCountryCode(data.country.toLowerCase())
                        } else if (value && value.length > 0) {
                          // Try to extract from phone number using libphonenumber-js
                          try {
                            const phoneNumber = parsePhoneNumber(`+${value}`)
                            if (phoneNumber && phoneNumber.country) {
                              setSelectedCountryCode(phoneNumber.country.toLowerCase())
                            }
                          } catch (e) {
                            // If parsing fails, keep current country code
                          }
                        }
                      }}
                      onCountryChange={(countryCode) => {
                        if (countryCode) {
                          setSelectedCountryCode(countryCode.toLowerCase())
                        }
                      }}
                      inputStyle={{
                        width: '100%',
                        paddingRight: inputMobileNumber && isValidPhoneNumber(`+${inputMobileNumber}`) ? '35px' : '7px'
                      }}
                      containerStyle={{
                        width: '100%',
                        position: 'relative'
                      }}
                      buttonStyle={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        borderRight: '1px solid #d9d9d9',
                        borderRadius: '5px 0 0 5px'
                      }}
                      dropdownStyle={{
                        zIndex: 99999
                      }}
                      enableSearch={true}
                    />
                    {inputMobileNumber && isValidPhoneNumber(`+${inputMobileNumber}`) && (
                      <span style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#25D366',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        zIndex: 10,
                        pointerEvents: 'none',
                        backgroundColor: '#ffffff',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        justifyContent: 'center',
                        lineHeight: '24px'
                      }}>
                        ✓
                      </span>
                    )}
                  </CAMCMaxWithRelativeContainer>
                  {/* Invisible reCAPTCHA container - positioned absolutely to not affect layout */}
                  <CAMCCaptcha id="recaptcha-container"></CAMCCaptcha>
                  <CAMCGeneralInputLabel style={{ marginTop: '16px', marginBottom: '10px', display: 'block', fontSize: '13px', letterSpacing: '0.04em', textTransform: 'uppercase', color: '#64748b' }}>
                    Get a verification code
                  </CAMCGeneralInputLabel>
                  <div style={{
                    display: 'grid',
                    gap: '10px',
                    gridTemplateColumns: isSmallScreen ? '1fr' : '1fr 1fr',
                    width: '100%',
                  }}>
                    {/* WhatsApp first — highest-deliverability for our target market. */}
                    <CAMCGeneralButton
                      onClick={async () => {
                        // Prevent multiple clicks - check if already processing
                        if (sendingOtpMethod === 'whatsapp' || userInputsDisabled) {
                          return
                        }

                        if (inputMobileNumber?.length === 0) {
                          setErrorText('Please enter your mobile number')
                          return
                        } else if (!isValidPhoneNumber(`+${inputMobileNumber}`)) {
                          setErrorText('Please enter a valid mobile number')
                          return
                        } else {
                          setSendingOtpMethod('whatsapp')
                          setUserInputsDisabled(true)
                          setErrorText(null)
                          try {
                            await sendWhatsAppOtpRequest(
                              `+${inputMobileNumber}`,
                              setShowOtpInput,
                              setErrorText,
                              setMobileNumberInputDisabled,
                              setWhatsappSessionId,
                              setWhatsappOtpExpiry,
                              setWhatsappOtpCountdown,
                              setWhatsappResendCountdown,
                              setOtpMethod,
                            )
                          } catch (error) {
                            // Error already handled in sendWhatsAppOtpRequest
                            setSendingOtpMethod(null)
                          } finally {
                            setUserInputsDisabled(false)
                            setSendingOtpMethod(null)
                          }
                        }
                      }}
                      disabled={(sendingOtpMethod !== null && sendingOtpMethod !== 'whatsapp') || (userInputsDisabled && sendingOtpMethod !== 'whatsapp') || !inputMobileNumber || !isValidPhoneNumber(`+${inputMobileNumber}`)}
                      success
                      {...(sendingOtpMethod === 'whatsapp' ? { loading: true } : {})}
                      style={{ 
                        flex: 1, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        gap: '8px',
                        minHeight: '40px'
                      }}
                    >
                      {sendingOtpMethod === 'whatsapp' ? (
                        <>
                          <Spinner animation="border" variant="light" size="sm" />
                          <span>Sending code&hellip;</span>
                        </>
                      ) : (
                        <>
                          <WhatsAppIcon sx={{ fontSize: '20px', color: '#25D366' }} />
                          <span>Send code via WhatsApp</span>
                        </>
                      )}
                    </CAMCGeneralButton>

                    {/* SMS — secondary. Same visual footprint as the WhatsApp
                        button but rendered as a subtle outlined button so
                        WhatsApp reads as the primary recommended path. */}
                    <CAMCGeneralButton
                      onClick={async () => {
                        if (sendingOtpMethod === 'sms' || userInputsDisabled) {
                          return
                        }

                        if (inputMobileNumber?.length === 0) {
                          setErrorText('Please enter your mobile number')
                          return
                        } else if (!isValidPhoneNumber(`+${inputMobileNumber}`)) {
                          setErrorText('Please enter a valid mobile number')
                          return
                        } else {
                          setSendingOtpMethod('sms')
                          setUserInputsDisabled(true)
                          setErrorText(null)
                          try {
                            await sendOtp(
                              `+${inputMobileNumber}`,
                              setShowOtpInput,
                              setErrorText,
                              setMobileNumberInputDisabled,
                              setConfirmationResultMobileLogin,
                              setOtpMethod,
                            )
                          } catch (error) {
                            // Error already handled in sendOtp
                          } finally {
                            setUserInputsDisabled(false)
                            setSendingOtpMethod(null)
                          }
                        }
                      }}
                      disabled={
                        (sendingOtpMethod !== null && sendingOtpMethod !== 'sms') ||
                        (userInputsDisabled && sendingOtpMethod !== 'sms') ||
                        !inputMobileNumber ||
                        !isValidPhoneNumber(`+${inputMobileNumber}`)
                      }
                      {...(sendingOtpMethod === 'sms' ? { loading: true } : {})}
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                      }}
                    >
                      {sendingOtpMethod === 'sms' ? (
                        <>
                          <Spinner animation="border" size="sm" />
                          <span>Sending code&hellip;</span>
                        </>
                      ) : (
                        <>
                          <SmsIcon sx={{ fontSize: '20px', color: '#475569' }} />
                          <span>Send code via SMS</span>
                        </>
                      )}
                    </CAMCGeneralButton>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    padding: '12px 14px',
                    background: '#f5f3ff',
                    border: '1px solid #ddd6fe',
                    borderRadius: '12px',
                    fontSize: '13px',
                    color: '#5b21b6',
                    marginTop: '4px',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}>
                    <span aria-hidden="true">✓</span>
                    <span>
                      Code sent via {otpMethod === 'whatsapp' ? 'WhatsApp' : 'SMS'} to +{inputMobileNumber}
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setShowOtpInput(false)
                      setInputOtp('')
                      setErrorText(null)
                      setOtpMethod(null)
                      setMobileNumberInputDisabled(false)
                    }}
                    style={{
                      marginTop: '6px',
                      background: 'transparent',
                      border: 0,
                      padding: 0,
                      color: '#6d28d9',
                      fontWeight: 600,
                      fontSize: '12px',
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      textUnderlineOffset: '3px',
                    }}
                  >
                    Use a different number
                  </button>
                </div>
              )}
              {showOtpInput && (
                <>
                  <CAMCMaxWithRelativeContainer>
                    <CAMCGeneralInputLabel htmlFor="otp">
                      Enter OTP
                      {userInputsDisabled && (
                        <span style={{ 
                          marginLeft: '8px', 
                          fontSize: '14px', 
                          fontWeight: 'normal',
                          color: '#514387',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}>
                          <Spinner animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
                          Verifying...
                        </span>
                      )}
                    </CAMCGeneralInputLabel>
                    <div style={{ marginTop: '10px' }}>
                      <OtpInput
                        value={inputOtp || ''}
                        onChange={setInputOtp}
                        numInputs={6}
                        onComplete={async (otp) => {
                          if (otp && otp.length === 6 && !userInputsDisabled) {
                            setUserInputsDisabled(true)
                            try {
                              if (otpMethod === 'whatsapp') {
                                if (!whatsappSessionId) {
                                  setErrorText('Session expired. Please request a new code')
                                  setShowOtpInput(false)
                                  setUserInputsDisabled(false)
                                  return
                                }
                                await verifyWhatsAppOtpRequest(
                                  `+${inputMobileNumber}`,
                                  otp,
                                  whatsappSessionId,
                                  setErrorText,
                                  doBasicOnboardingInside,
                                  setBasicOnboardingFlowVisible,
                                  setProfileDataForBasicOnboarding,
                                  beforeReloadFunction,
                                  redirectToURI,
                                  setShowOtpInput,
                                )
                              } else {
                                await verifyOtp(
                                  otp,
                                  confirmationResultMobileLogin,
                                  setErrorText,
                                  doBasicOnboardingInside,
                                  setBasicOnboardingFlowVisible,
                                  setProfileDataForBasicOnboarding,
                                  beforeReloadFunction,
                                  redirectToURI,
                                )
                              }
                            } finally {
                              setUserInputsDisabled(false)
                            }
                          }
                        }}
                        autoFocus={true}
                        disabled={userInputsDisabled}
                        maxWidth="315px"
                        boxSize="48px"
                        mobileBoxSize="44px"
                        smallMobileBoxSize="40px"
                        fontSize="20px"
                        mobileFontSize="18px"
                        smallMobileFontSize="16px"
                        gap="8px"
                        mobileGap="6px"
                        smallMobileGap="4px"
                        background="#ffffff"
                        textColor="#242424"
                        borderColor="#707070"
                        focusBorderColor="#514387"
                        borderRadius="8px"
                      />
                    </div>
                  </CAMCMaxWithRelativeContainer>
                  <CAMCResendOtpContainer>
                    {resendOtpAttempts > 3 ? (
                      <div style={{ color: '#cc0000', fontSize: '13px' }}>
                        You have reached maximum attempts. Please try again later.
                      </div>
                    ) : (
                      <>
                        <div>Didn&apos;t receive the code?</div>
                        {/* Show WhatsApp OTP expiry countdown if applicable */}
                        {otpMethod === 'whatsapp' && whatsappOtpCountdown > 0 && (
                          <div style={{ 
                            fontSize: '12px', 
                            color: '#707070', 
                            marginBottom: '8px',
                            textAlign: 'center'
                          }}>
                            OTP expires in {Math.floor(whatsappOtpCountdown / 60)}:{(whatsappOtpCountdown % 60).toString().padStart(2, '0')}
                          </div>
                        )}
                        {/* Resend cooldown for SMS, or show resend button for WhatsApp when OTP expired */}
                        {(otpMethod === 'sms' && secondsTimeOut > 0) || (otpMethod === 'whatsapp' && whatsappResendCountdown > 0) ? (
                          <span data-disabled="true">
                            Resend in {otpMethod === 'whatsapp' ? whatsappResendCountdown : secondsTimeOut}s
                          </span>
                        ) : (
                          <span
                            onClick={async () => {
                              // Prevent multiple clicks - check if already processing
                              if (userInputsDisabled || mobileNumberInputDisabled) {
                                return
                              }
                              
                              setUserInputsDisabled(true)
                              setMobileNumberInputDisabled(true)
                              try {
                                if (otpMethod === 'whatsapp') {
                                  await sendWhatsAppOtpRequest(
                                    `+${inputMobileNumber}`,
                                    setShowOtpInput,
                                    setErrorText,
                                    setMobileNumberInputDisabled,
                                    setWhatsappSessionId,
                                    setWhatsappOtpExpiry,
                                    setWhatsappOtpCountdown,
                                    setWhatsappResendCountdown,
                                    setOtpMethod,
                                  )
                                } else {
                                  await resendOtp(
                                    `+${inputMobileNumber}`,
                                    setShowOtpInput,
                                    setErrorText,
                                    setMobileNumberInputDisabled,
                                    setConfirmationResultMobileLogin,
                                    resetSecondsTimeout,
                                    increaseCountResendOtp,
                                    setOtpMethod,
                                  )
                                }
                                if (otpMethod === 'sms') {
                                  resetSecondsTimeout()
                                }
                                increaseCountResendOtp()
                              } catch (error) {
                                // Error already handled
                              } finally {
                                setUserInputsDisabled(false)
                                setMobileNumberInputDisabled(false)
                              }
                            }}
                          >
                            Resend code
                          </span>
                        )}
                      </>
                    )}
                  </CAMCResendOtpContainer>
                </>
              )}
            </CAMCMaxWithRelativeContainer>
          )}

          {errorText && (
            <CAMCErrorText>
              <ErrorIcon sx={{ fontSize: '16px' }} />
              {errorText}
            </CAMCErrorText>
          )}
          
          {proceedingToLogin && (
            <div style={{ 
              width: '100%', 
              maxWidth: '315px', 
              color: '#514387', 
              fontSize: '14px',
              textAlign: 'center',
              marginTop: '-10px'
            }}>
              Proceeding to login...
            </div>
          )}

          {!(activeInputType === 'mobile' && !showOtpInput) && (
            <CAMCGeneralButton
              onClick={() => handleNext(doBasicOnboardingInside)}
              success
              disabled={userInputsDisabled}
            >
              {userInputsDisabled ? (
                <Spinner animation="border" variant="light" size="sm" />
              ) : (activeInputType === 'mobile' && showOtpInput) || (activeInputType === 'email' && showEmailOtpInput) ? (
                'Verify & Continue'
              ) : (
                'Next'
              )}
            </CAMCGeneralButton>
          )}

          {/* generic stuff below this except last some, same for login and signup */}

          <DisplayFlex style={{ width: '100%', gap: '12px', maxWidth: '315px', alignItems: 'center' }}>
            <CAMCSeparator />
            <div style={{ fontSize: '13px', color: '#94a3b8', fontWeight: 500, letterSpacing: '0.04em', textTransform: 'uppercase' }}>or</div>
            <CAMCSeparator />
          </DisplayFlex>

          {useOtherMethods && unSecureSetupData?.loginPolicy?.login && (
            <div
              style={{
                display: 'grid',
                gap: '10px',
                width: '100%',
                // Single column on phones; two-up on desktop so Google sits
                // next to the mobile/email switcher and the modal stays short.
                gridTemplateColumns: isSmallScreen ? '1fr' : '1fr 1fr',
              }}
            >
              {unSecureSetupData.loginPolicy.login.google && (
                <CAMCSocialLoginComponent
                  type="google"
                  isActive={activeInputType === 'google'}
                  clickFunction={() => {
                    resetTogether()
                    handleGoogleLogin(
                      handleAfterLoginCAMC,
                      setErrorText,
                      doBasicOnboardingInside,
                      setBasicOnboardingFlowVisible,
                      setProfileDataForBasicOnboarding,
                      beforeReloadFunction,
                    )
                  }}
                />
              )}
              {unSecureSetupData.loginPolicy.login.mobile && activeInputType !== 'mobile' && (
                <CAMCSocialLoginComponent
                  type="mobile"
                  isActive={false}
                  clickFunction={() => {
                    resetTogether()
                    setActiveInputType('mobile')
                  }}
                />
              )}
              {unSecureSetupData.loginPolicy.login.usernamePassword && activeInputType !== 'email' && (
                <CAMCSocialLoginComponent
                  type="email"
                  isActive={false}
                  clickFunction={() => {
                    resetTogether()
                    setActiveInputType('email')
                  }}
                />
              )}
              {/* Facebook and Apple login intentionally disabled in the UI.
                  Backend policy flags are untouched so the login handlers and
                  helpers remain importable and ready to re-enable via the
                  CLUBBED_AUTH_SOCIAL_PROVIDERS switch at the top of this file. */}
              {CLUBBED_AUTH_SOCIAL_PROVIDERS.facebook && unSecureSetupData.loginPolicy.login.facebook && (
                <CAMCSocialLoginComponent
                  type="facebook"
                  isActive={activeInputType === 'facebook'}
                  clickFunction={() => {
                    resetTogether()
                    handleFacebookLogin(
                      handleAfterLoginCAMC,
                      setErrorText,
                      doBasicOnboardingInside,
                      setBasicOnboardingFlowVisible,
                      setProfileDataForBasicOnboarding,
                      beforeReloadFunction,
                    )
                  }}
                />
              )}
              {CLUBBED_AUTH_SOCIAL_PROVIDERS.apple && unSecureSetupData.loginPolicy.login.apple && (
                <CAMCSocialLoginComponent
                  type="apple"
                  isActive={activeInputType === 'apple'}
                  clickFunction={() => {
                    resetTogether()
                    handleAppleLogin(
                      handleAfterLoginCAMC,
                      setErrorText,
                      doBasicOnboardingInside,
                      setBasicOnboardingFlowVisible,
                      setProfileDataForBasicOnboarding,
                      beforeReloadFunction,
                    )
                  }}
                />
              )}
            </div>
          )}

          <div
            style={{
              marginTop: '4px',
              paddingTop: '16px',
              borderTop: '1px solid #f1f5f9',
              textAlign: 'center',
              fontSize: '14px',
              color: '#64748b',
            }}
          >
            {authType === 'signup' ? (
              <>
                Already have an account?{' '}
                <button
                  type="button"
                  onClick={() => {
                    resetTogether()
                    setAuthType('login')
                  }}
                  style={{
                    background: 'transparent',
                    border: 0,
                    padding: 0,
                    fontFamily: 'inherit',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#7c3aed',
                    cursor: 'pointer',
                  }}
                >
                  Log in
                </button>
              </>
            ) : (
              <>
                New to AUMHUM?{' '}
                <button
                  type="button"
                  onClick={() => {
                    resetTogether()
                    setAuthType('signup')
                  }}
                  style={{
                    background: 'transparent',
                    border: 0,
                    padding: 0,
                    fontFamily: 'inherit',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#7c3aed',
                    cursor: 'pointer',
                  }}
                >
                  Create an account
                </button>
              </>
            )}
          </div>
        </>
      )}

      {basicOnboardingFlowVisible && (
        <>
          <CAMCHeading secondary>Please fill the following details</CAMCHeading>

          <CAMCMaxWithRelativeContainer>
            <CAMCGeneralInputLabel htmlFor="name">
              {nameFieldHeading || 'Name'}
            </CAMCGeneralInputLabel>
            <CAMCGeneralInput
              id="name"
              type="text"
              value={basicOnboardingDetails?.name}
              onChange={(e) =>
                setBasicOnboardingDetails((prev) => ({ ...prev, name: e.target.value }))
              }
            />
          </CAMCMaxWithRelativeContainer>

          <CAMCMaxWithRelativeContainer>
            <CAMCGeneralInputLabel htmlFor="age">Age</CAMCGeneralInputLabel>
            <CAMCGeneralInput
              id="age"
              type="number"
              value={basicOnboardingDetails?.age}
              onChange={(e) =>
                setBasicOnboardingDetails((prev) => ({ ...prev, age: e.target.value }))
              }
            />
          </CAMCMaxWithRelativeContainer>

          <CAMCMaxWithRelativeContainer>
            <CAMCGeneralInputLabel htmlFor="name">Gender</CAMCGeneralInputLabel>
            <RectangleRadioButton
              options={[
                { label: 'Male', id: 'male' },
                { label: 'Female', id: 'female' },
                { label: 'Non-Binary', id: 'nonBinary' },
              ]}
              selectedId={basicOnboardingDetails?.gender}
              selectionFunction={(id) =>
                setBasicOnboardingDetails((prev) => ({ ...prev, gender: id }))
              }
            />
          </CAMCMaxWithRelativeContainer>

          {basicOnboardingErrorText && (
            <CAMCErrorText>
              <ErrorIcon sx={{ fontSize: '16px' }} />
              {basicOnboardingErrorText}
            </CAMCErrorText>
          )}

          <CAMCGeneralButton
            success
            style={{ marginTop: '30px' }}
            onClick={() => handleNextBasicOnboarding(profileDataForBasicOnboarding)}
          >
            {basicOnboardingLoading ? (
              <Spinner animation="border" variant="light" size="sm" />
            ) : (
              'Continue'
            )}
          </CAMCGeneralButton>
        </>
      )}
    </CAMCParent>
  )
}
